import { TIndexTab } from '../../../types/redux';

export function getGraphValuesType(indexTab: TIndexTab) {
  switch (indexTab) {
    case 0:
      return 'thousands';
    case 1:
      return 'percentage';
    case 2:
      return 'thousands';
  }
}
